module.exports = __webpack_public_path__ + "static/media/ms-marvel-vol7.366376fb.jpg";